var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "23px",
    viewBox: "0 0 33 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Mastercard ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INSURANCE-//-Payment",
    transform: "translate(-203.000000, -388.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mastercard-",
    transform: "translate(203.000000, 388.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9986425,0.5 L3.00135749,0.5 C2.30789493,0.5 1.68326567,0.779305012 1.23174905,1.23164765 C0.77860004,1.68562568 0.5,2.31348517 0.5,3.00684834 L0.5,19.9931517 C0.5,20.6886424 0.778719049,21.3148544 1.23045574,21.7674175 C1.68329974,22.22109 2.30961822,22.5 3.00135749,22.5 L29.9986425,22.5 C30.6921051,22.5 31.3167343,22.220695 31.7682509,21.7683523 C32.2214,21.3143743 32.5,20.6865148 32.5,19.9931517 L32.5,3.00684834 C32.5,2.31135763 32.221281,1.68514563 31.7695443,1.23258251 C31.3167003,0.778910046 30.6903818,0.5 29.9986425,0.5 Z",
    id: "Rectangle-Copy-4",
    stroke: "#E6E7E8",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "mc_symbol",
    transform: "translate(6.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    opacity: 0,
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 19.9075758,
    height: 12.9850575
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FF5F00",
    x: 7.32878788,
    y: 2.26229885,
    width: 5.25151515,
    height: 8.45896552
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.86969697,6.49252874 C7.86837838,4.84212666 8.63660739,3.28278072 9.9530303,2.2637931 C7.7166349,0.530467508 4.50508141,0.78294137 2.57536332,2.84378284 C0.645645223,4.90462432 0.645645223,8.0819274 2.57536332,10.1427689 C4.50508141,12.2036104 7.7166349,12.4560842 9.9530303,10.7227586 C8.63618846,9.70344741 7.86791252,8.14345518 7.86969697,6.49252874 Z",
    id: "Path",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3830303,10.4654963 L18.3830303,9.76246604 L18.549697,9.76246604 L18.549697,9.61701149 L18.1530303,9.61701149 L18.1530303,9.76246604 L18.309697,9.76246604 L18.309697,10.4654963 L18.3830303,10.4654963 Z M19.1530303,10.4654963 L19.1530303,9.61701149 L19.0330303,9.61701149 L18.8930303,10.2230721 L18.7530303,9.61701149 L18.6330303,9.61701149 L18.6330303,10.4654963 L18.719697,10.4654963 L18.719697,9.8230721 L18.849697,10.3745873 L18.939697,10.3745873 L19.069697,9.8230721 L19.069697,10.4654963 L19.1530303,10.4654963 Z",
    id: "Shape",
    fill: "#F79E1B",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7787879,6.49252874 C18.7787879,8.55211431 17.5862759,10.4308788 15.7078417,11.3309037 C13.8294075,12.2309286 11.5947863,11.9942027 9.9530303,10.7212644 C11.2688788,9.70141165 12.0371657,8.14227304 12.0371657,6.49178161 C12.0371657,4.84129018 11.2688788,3.28215157 9.9530303,2.26229885 C11.5947863,0.989360543 13.8294075,0.752634638 15.7078417,1.65265953 C17.5862759,2.55268443 18.7787879,4.43144891 18.7787879,6.49103448 L18.7787879,6.49252874 Z",
    id: "Path",
    fill: "#F79E1B"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardIcon);
export default __webpack_public_path__ + "static/media/mastercard-icon.03042ebf.svg";
export { ForwardRef as ReactComponent };